jQuery(function($) {
  // Regular accordion toggle
  var accordionToggles = document.querySelectorAll('.accordion__toggle');
  for (var i = 0, len = accordionToggles.length; i < len; i++) {
    var accordionToggle = accordionToggles[i];
    accordionToggle.addEventListener('click', function(e) {
      this.parentNode.classList.toggle('accordion__item--active');
      e.preventDefault();
      $('.accordion__toggle__icon', this).toggleClass('is-toggled');
    });
  }

  // Accordion modification for student life filtering
  $('.filter__accordion__toggle').click(function(e) {
    e.preventDefault();

    // If someone is clicking on this link, and it's already active, just
    // remove all the content since we're not showing anything new.
    var accToggle = $('.filter__accordion__toggle');
    if($(this).hasClass('active')) {
      $('.filter__accordion__content.active').remove();
      $(this).removeClass('active');
      $(this).parent().removeClass('active');
      $('.accordion__toggle__icon', this).removeClass('is-toggled');

    }

    // Otherwise, remove all the content, but then also show our new content.
    else {
      $('.filter__accordion__content.active').remove();
      $('.filter__accordion__toggle').removeClass('active');
      $('.filter__accordion__toggle').parent().removeClass('active');
      $('.accordion__toggle__icon').removeClass('is-toggled');

      // Get the content we're appending
      var content = $(this)
      .parent()
      .children('.filter__accordion__content')
      .clone()
      .addClass('active');

      // Iterate through all of the tabs, and append the content before the
      // first one we find that's lower than the selected tab.
      var contentAdded = false;
      var myPosition = $(this).parent().position().top;
      $('.filter__accordion__item').each(function(index, item) {
        if ($(item).css('display') != 'none') {
          var theirPosition = $(item).position().top;
          if((!contentAdded) && (theirPosition > myPosition)) {
            content.insertBefore($(item)).show();
            contentAdded = true;
          }
        }

      });

      if (!contentAdded) {
        content.insertAfter($('.filter__accordion__item').last()).show();
      }

      $(this).addClass('active');
      $(this).parent().addClass('active');
      $('.accordion__toggle__icon', this).addClass('is-toggled');
    }

  });
});